module.exports = __webpack_public_path__ + "img/self_learning.f2937049.svg";